import * as objectUtil from './objectUtil'

/**
数组工具类
ver 1.0.0
*/

/**
获取数组指定属性拼接为用特定符号连接的字符串
 * @param {array} arr 数组
 * @param {String} paramName 指定连接的属性名
 * @param {String} separator 特定符号
 * @param {String} customReturn 不满足数组时自定义的返回值 默认-1
*/
export const getArrayLinkWithSeparator = function (arr, paramName, separator, customReturn = -1) {
  //   if (!Array.isArray(arr)) return -1;
  if (!Array.isArray(arr)) return customReturn // 兼容盘点单选择货位的时候如果没有选择货位默认返回-1导致后台无法进行下一步逻辑
  // var str = ''
  var temp = []
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    item[paramName]
    temp.push(item[paramName])
  }

  return temp.join(separator)
}

/**
获取在数组中的位置
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，number} value 对比值
*/
export const getArrayIndexByFieldValue = function (arr, field, value) {
  if (!arr) return -1
  for (var i = 0, len = arr.length; i < len; i++) {
    var item = arr[i]
    if (objectUtil.getValueByPath(item, field) === value) return i
  }
  return -1
}

/**
获取在数组中的条目
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，number} value 对比值
*/
export const getArrayItemByFieldValue = function (arr, field, value) {
  if (!arr) return null
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    if (objectUtil.getValueByPath(item, field) === value) return item
  }

  return null
}

/**
根据两个字段（两个字段都满足）获取在数组中的条目
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，number} value 对比值
 * @param {String，number} fieldTwo 第二个属性名
 * @param {String，number} valueTwo 第二个对比值
*/
export const getArrayItemByTwoFieldValue = function (arr, field, value, fieldTwo, valueTwo) {
  if (!arr) return null
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    if (
      objectUtil.getValueByPath(item, field) === value &&
      objectUtil.getValueByPath(item, fieldTwo) === valueTwo
    )
      return item
  }

  return null
}

/**
 * 数组元素交换位置
 * @param {array} arr 数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */
export const swapArray = function (arr, index1, index2) {
  arr[index1] = arr.splice(index2, 1, arr[index1])[0]
  return arr
}

/**
 * 数组元素移动到某个数据后，或前面
 * @param {array} arr 数组
 * @param {number} index 是当前元素下标
 * @param {number} tindex 是拖动到的位置下标。
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */
export const moveArrayFromTo = function (arr, index, tindex) {
  //如果当前元素在拖动目标位置的下方，先将当前元素从数组拿出，数组长度-1，我们直接给数组拖动目标位置的地方新增一个和当前元素值一样的元素，
  //我们再把数组之前的那个拖动的元素删除掉，所以要len+1
  if (index > tindex) {
    arr.splice(tindex, 0, arr[index])
    arr.splice(index + 1, 1)
  } else {
    //如果当前元素在拖动目标位置的上方，先将当前元素从数组拿出，数组长度-1，我们直接给数组拖动目标位置+1的地方新增一个和当前元素值一样的元素，
    //这时，数组len不变，我们再把数组之前的那个拖动的元素删除掉，下标还是index
    arr.splice(tindex + 1, 0, arr[index])
    arr.splice(index, 1)
  }
  return arr
}

/**
 判断对象数组中的指定属性是否包含，对应对值。
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，array} value 对比值
 * return  {boolean} 是否包含
 比如 1：
  arr=[{status:"草稿"}]
  field="status"
  value="草稿"

  return =》 true

  比如 2：
   arr=[{status:"草稿"}]
   field="status"
   value=["草稿","编辑"]

   return =》 true
*/
export const containFieldValue = function (arr, field, value) {
  if (!arr || arr.length == 0) return false

  //每行数据都包含，才返回true，只要有1行不满足则返回false
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    if (Array.isArray(value)) {
      if (value.indexOf(objectUtil.getValueByPath(item, field)) === -1) {
        // console.log("containFieldValue isArray ", value, value.indexOf(
        //   objectUtil.getValueByPath(item, field)));
        return false
      }
    } else if (!(objectUtil.getValueByPath(item, field) === value)) {
      // console.log("containFieldValue noisArray ", value, objectUtil.getValueByPath(
      //     item, field) ===
      //   value);
      return false
    }
  }

  return true
}
/**
 判断对象数组中的指定属性是否相同。
 * @param {array} arr 数组
 * @param {String} field 属性名
 * return  {boolean} 是否包含
 比如 1：
 arr=[{id:1,status:"草稿"},{id:2,status:"草稿"}]
 field="status"
 return =》 true

 比如 2：
 arr=[{id:1,status:"草稿"},{id:2,status:"编辑"}]
 field="status"

 return =》 false
 */
export const containFieldIsEquality = function (arr, field) {
  if (!arr || arr.length == 0) return false
  let value = objectUtil.getValueByPath(arr[0], field)
  if (!value) {
    return false
  }

  return containFieldValue(arr, field, value)
}
/**
 判断对象数组中的指定属性是否不包含，对应对值。
 * @param {array} arr 数组
 * @param {String} field 属性名
 * @param {String，array} value 对比值
 * return  {boolean} 是否包含
 比如 1：
  arr=[{status:"草稿"}]
  field="status"
  value="草稿"

  return =》 true

  比如 2：
   arr=[{status:"草稿"}]
   field="status"
   value=["草稿","编辑"]

   return =》 true
*/
export const notContainFieldValue = function (arr, field, value) {
  if (!arr || arr.length == 0) return false

  //每行数据都不包含，才返回true，只要有1行不满足则返回false
  for (var i = 0; i < arr.length; i++) {
    var item = arr[i]
    //如果field 不存在直接 返回false
    if (!item[field]) return false
    if (Array.isArray(value)) {
      if (value.indexOf(objectUtil.getValueByPath(item, field)) !== -1) {
        // console.log("notContainFieldValue isArray ", value, value.indexOf(
        //   objectUtil.getValueByPath(item, field)));
        return false
      }
    } else if (!(objectUtil.getValueByPath(item, field) !== value)) {
      // console.log("notContainFieldValue noisArray ", value, objectUtil.getValueByPath(
      //     item, field) !==
      //   value);
      return false
    }
  }

  return true
}
//value 对比的字段
export const customSort = function (value) {
  return function (pre, next) {
    let value1 = pre[value]
    let value2 = next[value]
    return value1 - value2
  }
}

/**
 * 判断对象数组中，指定字段(Field)的值是否至少有一项等于指定的值(Value)
 * 是，则返回 True；否，则返回 False。类似 Array.some
 * @param {Array} arr 数组
 * @param {String} field 字段/属性名
 * @param {Any} value 指定的值
 * @returns {Boolean} 返回判断结果
 */
export const someFieldValue = function (arr, field, value) {
  if (!arr || arr.length == 0) return false
  return arr.some((im) => objectUtil.getValueByPath(im, field) == value) // == 表示 null 和 undefined 是相等的
}

/**
 * 判断对象数组中，指定字段(Field)的值是否全部等于指定的值(Value)
 * 是，则返回 True；否，则返回 False。类似 Array.every
 * @param {Array} arr 数组
 * @param {String} field 字段/属性名
 * @param {Any} value 指定的值
 * @returns {Boolean} 返回判断结果
 */
export const everyFieldValue = function (arr, field, value) {
  if (!arr || arr.length == 0) return false
  return arr.every((im) => objectUtil.getValueByPath(im, field) == value) // == 表示 null 和 undefined 是相等的
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值的key
 * @returns 数组中所有元素对应key的值
 */
export function getKeysByPath(source, path) {
  if (!source?.length || !path) {
    return []
  }
  return source.map((item) => objectUtil.getValueByPath(item, path))
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值key
 * @param {String} filterPath 需要过滤的key
 * @returns 数组中所有元素对应key的值
 */
export function getKeysByPathNotNull(source, path, filterPath) {
  if (!source?.length || !path) {
    return []
  }
  return source
    .filter((item) => objectUtil.getValueByPath(item, filterPath))
    .map((item) => objectUtil.getValueByPath(item, path))
}

/**
 *
 * @param {Array} source 数组
 * @param {String} path 需要返回值的key
 * @returns 数组中所有元素对应key的值并且该值不为空 并且 去重（uniqueKey 默认为 id）
 */
export function getKeysByPathExist(source, path, uniqueKey = 'id') {
  if (!source?.length || !path) {
    return []
  }
  return source.reduce((pre, cur) => {
    const resItem = objectUtil.getValueByPath(cur, path)
    console.log('------', resItem)

    if (resItem) {
      let result = pre.filter(
        (im) =>
          objectUtil.getValueByPath(im, uniqueKey) == objectUtil.getValueByPath(resItem, uniqueKey)
      )
      if (result.length <= 0) pre.push(resItem)
    }
    return pre
  }, [])
}

export function getMaxValue(arr) {
  if (!arr) return null
  if (!Array.isArray(arr) || arr.length === 0) return null
  return Math.max(...arr)
}

export function getNotNullArr(arr) {
  if (!arr) return []
  return arr.filter((item) => !!item)
}
